import { Link, useLocation } from "react-router-dom";
import {
  LayoutDashboard,
  UserPlus,
  Phone,
  CheckSquare,
  Users
} from "lucide-react";
import { useTranslation } from "react-i18next";

const menuItems = [
  { key: "dashboard", path: "/app", icon: <LayoutDashboard size={20} /> },
  { key: "create_customer", path: "/app/create-customer", icon: <UserPlus size={20} /> },
  { key: "telecalling", path: "/app/telecalls", icon: <Phone size={20} /> },
  { key: "tasks", path: "/app/tasks", icon: <CheckSquare size={20} /> },
  { key: "users", path: "/app/users", icon: <Users size={20} /> },
];


const SideNavbar = ({ isSidebarOpen,isMobileSidebarOpen, isRTL }) => {
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <>
      <aside
        className={`fixed top-0 ${isRTL ? "right-0" : "left-0"} h-full transition-all duration-300 shadow-md p-4 z-40 bg-white 
        ${isSidebarOpen ? "sm:w-64" : "sm:w-16"} hidden sm:block`}
      >
        {/* Logo and Title */}
        <div className="flex items-center gap-2 mb-6 h-10 overflow-hidden">
          <img src="/images/profile-image.png" alt="Logo" className="w-8 h-8 object-cover" />
          <span
            className={`text-xl font-bold text-primary transition-all duration-200 origin-left ${isSidebarOpen ? "opacity-100 scale-100" : "opacity-0 scale-0"
              }`}
          >
            V-Task
          </span>
        </div>

        {/* Menu Items */}
        <nav className="space-y-4">
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`group flex items-center h-10 px-1 rounded transition-all duration-200 ${location.pathname === item.path
                  ? "bg-[var(--menu-active-bg)] text-[var(--menu-active-text)] font-semibold"
                  : "text-gray-700 hover:bg-gray-200"
                }`}
              title={!isSidebarOpen ? item.label : undefined}
            >
              <div className="w-6 h-full flex justify-center items-center text-xl"  title={t(`menu.${item.key}`)}>
                {item.icon}
              </div>
              <span
                className={`ml-2 truncate transition-all duration-200 ease-in-out whitespace-nowrap ${isSidebarOpen ? "opacity-100 scale-100" : "opacity-0 scale-0 w-0 overflow-hidden"
                  }`}
                  title={t(`menu.${item.key}`)}
              >
                 {t(`menu.${item.key}`)}
              </span>
            </Link>
          ))}
        </nav>
      </aside>
      {/* Mobile Sidebar */}
      {isMobileSidebarOpen && (
        <div
          className={`fixed top-0 ${isRTL ? "right-0" : "left-0"} h-full w-16 z-50 bg-white shadow-md sm:hidden transition-transform duration-300`}
        >
          <div className="flex justify-center items-center h-16 border-b">
            <img src="/images/profile-image.png" alt="Logo" className="w-8 h-8 object-cover" />
          </div>
          <nav className="mt-2 space-y-6 px-2">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex justify-center items-center h-10 w-full rounded ${location.pathname === item.path ? "bg-[var(--menu-active-bg)] text-[var(--menu-active-text)]" : "text-gray-700 hover:bg-gray-200"
                  }`}
                title={item.label}
              >
                <span className="text-xl" 
                  title={t(`menu.${item.key}`)}>{item.icon}</span>
              </Link>
            ))}
          </nav>
        </div>
      )}
    </>
  );
};

export default SideNavbar;
